module.exports = __webpack_public_path__ + "static/media/torre-expositor.c038eae9.svg";